import React,{Component} from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import { Container } from 'reactstrap';
import {
  AppFooter,
  AppHeader,
} from '@coreui/react';
import * as keys from '../../const/key/Key';

import routes from '../../routes';
import * as actionCreator from "../../store/Action";
import {connect} from "react-redux";
import './Style.scss'
import DefaultHeader from './GuestHeader'
import Cookies from "js-cookie";
import * as routeConstants from "../../const/route/Route";
import queryString from "query-string";

class DefaultLayout extends Component {
    loading = () =>  <span />;

  componentWillMount(){
    let token = Cookies.get(keys.ACCESS_TOKEN);
    let querySParam = queryString.parse(window.location.search);
    let querySParamBranch = querySParam.b;
    let querySParamStatus = querySParam.n;

    if (querySParamBranch) {
      localStorage.setItem(keys.GUEST_BRANCH_ID, querySParamBranch);

    }else if(querySParamStatus){
      localStorage.removeItem(keys.GUEST_BRANCH_ID);
      localStorage.removeItem(keys.GUEST_CACHE);
      localStorage.setItem(keys.GUEST_STATUS, querySParamStatus);
    }

    let branchId = querySParamBranch ? querySParamBranch : localStorage.getItem(keys.GUEST_BRANCH_ID);
    let guestStatus = querySParamStatus ? querySParamStatus : localStorage.getItem(keys.GUEST_STATUS);

    let guestIsLogin = localStorage.getItem(keys.GUEST_CACHE);

    // console.log("guestIsLogin",guestIsLogin);
    // console.log("branchId",branchId);
    // console.log("guestStatus",guestStatus);

    this.props.setGuestUserDetails({
      guestIsLogin:guestIsLogin,branchId:branchId,guestStatus:guestStatus,pinRequired: branchId !== null
    });

    if(guestIsLogin && token){
      // if(branchId){
      //   this.props.history.push(`${routeConstants.GUEST_ROUTE_PATH}/profile`);
      // }else if(guestStatus){
      //   this.props.history.push(`${routeConstants.GUEST_ROUTE_PATH}/public-user/profile`);
      // }
      this.props.history.push(`${routeConstants.GUEST_ROUTE_PATH}/profile`);
    }else{
      this.props.history.push(`${routeConstants.GUEST_ROUTE_PATH}/login`);
    }
  }

  componentDidMount(){
    document.title = "Miracle Dome";
  }

  render() {
    return (
      <div className="app guest-layout">
        <AppHeader fixed>

          <DefaultHeader/>

        </AppHeader>
        <div className="app-body">
          <main className="main recept" style={{marginLeft:'0px!important'}}>

            <Container fluid>

              <Switch>
                {routes.map((route, idx) => {
                  return route.component ? (
                    <Route
                      key={idx}
                      path={route.path}
                      exact={route.exact}
                      name={route.name}
                      render={props => (
                        <route.component route_name={route.name} {...props} />

                      )} />
                  ) : (null);
                })}
                {/*<Redirect from={routeConstants.GUEST_ROUTE_PATH} to={`${routeConstants.GUEST_ROUTE_PATH}/dashboard`} />*/}
              </Switch>

            </Container>
          </main>
        </div>
        <AppFooter className={"footer-recept"}>

          <span className="mll-auto" ><a>Miracle Dome</a> &copy; 2024</span>
          <span className="ml-auto" style={{fontSize:'13px'}}>Solution partner <a target="_blank" href={"https://business.dialog.lk/"} style={{textDecoration:'none',color:'#1f1f1f!important'}}>Dialog Enterprise</a></span>

        </AppFooter>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  is_spin: state.spinnerReducer.is_spin,
  usr_obj: state.userReducer.user,
  guest_data: state.guestUserReducer.guestUser
});

const mapDispatchToProps = (dispatch) => {
  return {


    callAllBuildings : (data) => dispatch(actionCreator.callAllBuildings(data)), // Get All Buildings Of Corporate
    callAllWifiPackages : (data) => dispatch(actionCreator.callAllWifiPackages(data)), // Get All Wifi Packges Of Corporate
    callAllCount : (data) => dispatch(actionCreator.callAllCount(data)), // Get All counts

    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    //user data handler:
    userHandler: (data) => dispatch(actionCreator.userHandler(data)),
    // history reducer
    browserHistoryHandler: (data) => dispatch(actionCreator.browserHistoryHandler(data)),
    // guest user reducer
    setGuestUserDetails: (data) => dispatch(actionCreator.setGuestUserDetails(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DefaultLayout);
